export default __webpack_public_path__ + "static/webtop-8a7126dc7dd4e2dfb6a642af20162969.webp";